import axios from "axios";
import { apiConfiguration } from "plumbing/api";

export const ensureRiderIndentityExists = () => {
  const url = `${apiConfiguration.apiUrl}/riders`;
  console.log("ensuring rider exists...");
  return axios.post(url);
};
